import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/series" },
  { label: "综艺", to: "/category/variety" },
  { label: "排行", to: "/#popular" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px] gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0 cursor-pointer"
            aria-label="青青草视频 首页"
          >
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-leaf-fill text-xl text-background-50" />
            </span>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
              青青草<span className="text-primary-400">视频</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? "text-primary-300"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-200/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <form
              onSubmit={handleSearch}
              className="hidden sm:flex items-center bg-background-200/70 rounded-full pl-4 pr-1 h-10 w-44 lg:w-64"
            >
              <i className="ri-search-line text-foreground-500 text-base" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视名称"
                className="flex-1 bg-transparent px-2 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none"
              />
              <button
                type="submit"
                className="w-8 h-8 rounded-full bg-primary-500 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-arrow-right-line" />
              </button>
            </form>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-900 bg-background-200/70 cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50/98 backdrop-blur px-4 pb-5 pt-3 animate-fade-in">
          <form
            onSubmit={handleSearch}
            className="flex items-center bg-background-200/70 rounded-full pl-4 pr-1 h-11 mb-3"
          >
            <i className="ri-search-line text-foreground-500 text-base" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视名称"
              className="flex-1 bg-transparent px-2 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none"
            />
            <button
              type="submit"
              className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-300 bg-background-200/60"
                      : "text-foreground-700 hover:bg-background-200/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}